import { useEffect, useState } from "react";
import DivStyle from "../style/div.component";
import Table from "../table/Table";
import Page from "../table/paging";
import InputFormStyle from "../style/input_form.component";
import Icon from "@mdi/react";
import { mdiMagnify } from "@mdi/js";
import AdminAPI from "../../api/admin";
import { ICharge } from "./interface/interface";

const UserChargeBoard = () => {
  const [dataList, setDataList] = useState<ICharge[]>([]);
  const [searchDataList, setSearchDataList] = useState<ICharge[]>([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const pageSize = 10;

  const [dayChargePoints, setDayChargePoints] = useState(0);
  const [totalChargePoints, setTotalChargePoints] = useState(0);
  const headers = [
    {
      text: "날짜 (최근 순)",
      align: "center",
      sortable: false,
      value: "createdAt",
      width: "16%",
    },
    {
      text: "아이디",
      align: "center",
      sortable: false,
      value: "ownerId",
      width: "7%",
    },
    {
      text: "닉네임",
      align: "center",
      sortable: false,
      value: "ownerName",
      width: "49%",
    },
    {
      text: "충전타입",
      align: "center",
      sortable: false,
      value: "chargeProduct",
      width: "13%",
    },
    {
      text: "충전포인트",
      align: "center",
      sortable: false,
      value: "points",
      width: "15%",
    },
  ];
  function formatDate(dateString: string) {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, "0"); // 월은 0부터 시작하므로 1을 더합니다.
    const day = date.getDate().toString().padStart(2, "0");
    const hours = date.getHours().toString().padStart(2, "0");
    const minutes = date.getMinutes().toString().padStart(2, "0");
    const seconds = date.getSeconds().toString().padStart(2, "0");

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }
  const getList = async () => {
    const res = await AdminAPI.getAllChargeList();
    if (res && res.status === 200) {
      const updatedData = res.data.map((item: ICharge) => ({
        ...item,
        createdAt: formatDate(item.createdAt),
      }));

      const totalUsePoints = res.data.reduce(
        (accumulator: number, item: ICharge) => {
          // currentItem.usePoints가 숫자인지 확인하고, 아닐 경우 0으로 처리
          const chargePoints = Number(item.points) || 0;
          return accumulator + chargePoints;
        },
        0
      );
      setTotalChargePoints(totalUsePoints);
      setDataList(updatedData);
      const totalPages = Math.ceil(res.data.length / pageSize);
      setTotalPages(totalPages);
      setSearchDataList(updatedData);

      const messageList = res.data;
      const today = new Date().toISOString().split("T")[0];
      const todayList = messageList.filter((message: ICharge) =>
        message.createdAt.includes(today)
      );
      setDayChargePoints(
        todayList.reduce((accumulator: number, currentValue: ICharge) => {
          const chargePoints = Number(currentValue.points) || 0;
          return accumulator + chargePoints;
        }, 0)
      );
    }
  };

  const handleSearch = (search: string) => {
    setCurrentPage(1);

    if (!search.trim()) {
      setSearchDataList(dataList);
      const totalPages = Math.ceil(dataList.length / 10);
      setTotalPages(totalPages);
      return;
    }

    const filteredList = dataList.filter((item: ICharge) => {
      // 모든 객체의 키를 반복하여 해당 키의 값에 검색어가 포함되어 있는지 확인
      return Object.values(item).some((value) => {
        if (value)
          return value.toString().toLowerCase().includes(search.toLowerCase());
      });
    });

    setSearchDataList(filteredList);
    const totalPages = Math.ceil(filteredList.length / 10);
    setTotalPages(totalPages);
  };

  const numberFormat = (value: number) => {
    const NUMBER_FORMAT_REGX = /\B(?=(\d{3})+(?!\d))/g;
    return value.toString().replace(NUMBER_FORMAT_REGX, ",");
  };

  useEffect(() => {
    getList();
  }, []);
  return (
    <DivStyle
      width="100%"
      backgroundColor="#121212"
      height="100vh"
      display="flex"
      flex_direction="column"
      align_items="center"
      marginTop="65px"
    >
      <h4 style={{ color: "white", width: "auto", margin: "0" }}>
        - 1일 가맹점 포인트 충전 : {numberFormat(dayChargePoints)}
      </h4>
      <h4 style={{ color: "white", width: "auto", margin: "0" }}>
        - 누적 가맹점 포인트 충전 : {numberFormat(totalChargePoints)}
      </h4>

      <DivStyle
        width="80%"
        display="flex"
        backgroundColor="#1E1E1E"
        flex_direction="column"
        borderRadius="10px"
        marginTop="30px"
        marginBottom="60px"
      >
        <DivStyle
          width="100%"
          display="flex"
          flex_direction="row"
          justify_content="end"
          align_items="center"
        >
          <DivStyle
            width="50%"
            display="flex"
            justify_content="flex-end"
            flex_direction="row"
            align_items="center"
            marginRight="20px"
            marginTop="20px"
          >
            <InputFormStyle
              onChange={(e) => handleSearch(e.target.value)}
            ></InputFormStyle>
            <Icon path={mdiMagnify} size={1} style={{ color: "white" }} />
          </DivStyle>
        </DivStyle>
        <Table
          headers={headers}
          currentPage={currentPage}
          dataList={searchDataList}
        />
        <Page
          currentPage={currentPage}
          totalPages={totalPages}
          dataList={searchDataList}
          setCurrentPage={setCurrentPage}
        />
      </DivStyle>
    </DivStyle>
  );
};
export default UserChargeBoard;
